// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import videoWidget from './js/widgets/videoWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import cardWidget from './js/widgets/cardWidget.js';
import infographic from './js/widgets/infographic.js';
import hotButtons from './js/widgets/hotButtons.js';
import staticSponsors from './js/widgets/staticSponsors.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();
  if (globalThis.location.pathname === '/') {
    $(globalThis).load(function () {
      videoWidget();
    });
    seoWidget();
    cardWidget();
    infographic();
    hotButtons();
    staticSponsors();
    scrollerSponsors();
  }
});
